import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { MAIN } from '../components/Shell';
import { cn } from '../components/ui';

/** A page-level "nothing here": a heading and a line or two, left-aligned in the page's padding. */
export function EmptySection({ heading, children }: { heading: ReactNode; children: ReactNode }) {
  return (
    <section className="px-5 py-4 [&_p]:my-1">
      {heading}
      {children}
    </section>
  );
}

/** Anything that does not exist or is not yours: the API answers both the same way, and so do we. */
export function NotFoundPage({ bare }: { bare?: boolean }) {
  const body = (
    <EmptySection heading={<h1 className="m-0 mb-1.5 text-[18px]">Not found</h1>}>
      <p className="text-ink-muted">This page does not exist, or you are not a member of its workspace.</p>
      <p>
        <Link to="/">Back to your boards</Link>
      </p>
    </EmptySection>
  );
  return bare ? body : <main className={cn(MAIN, 'mx-auto max-w-[48rem]')}>{body}</main>;
}
